import { ICourse } from './course';

export type NotificatioForm = Record<enNotificationNames, NotificationTypes>;

export enum enNotificationNames {
  newContent = 'newContent',
  newCourseTrack = 'newCourseTrack',
  commentResponse = 'comment',
  sendEmailToStudents = 'sendEmailToStudents',
  news = 'news'
}

export interface NotificationTypes {
  email: boolean;
  push: boolean;
}
export interface IUnsubscribedProducer {
  id: number;
  name: string;
}

export interface INotificationItem {
  key: enNotificationNames;
  title: string;
  description: string;
  disablePush?: boolean;
}

export interface IUserNotification {
  course_id: number;
  course_title: string;
  cover_url: string;
  created_at: string;
  description: string;
  id: string;
  link: string;
  message: string;
  new_cover_url: string;
  payload: {
    type: string;
    value: string;
  };
  read: boolean;
  subtitle: string;
  target_url: string;
  title: string;
  producer_name: string;
  producer_avatar: string;
  course_hash: string;
}

export enum enNotificationOrigin {
  update,
  invite
}

export interface INotificationData {
  origin: enNotificationOrigin;
  course: Partial<INotificationCourse>;
  description?: string;
  hash?: string;
  type?: string;
  message?: string;
  title?: string;
  courseHash?: string;
}

export interface INotificationBounce {
  exists: boolean;
}

interface INotificationCourse {
  producer: Partial<ICourse['producer']>;
  author: Partial<ICourse['author']>;
  courseLink: string;
  title: string;
  cover: string;
  courseHash: string;
}
